import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'middleEllipsis'
})
export class MiddleEllipsisPipe implements PipeTransform {

  transform(value: string, startEllipsIndex: number, terminateEllipsIndexFromEnd: number): any {
    if (value) {
      const endIndex = value.length - terminateEllipsIndexFromEnd;
      if (endIndex > 0) {
        const ellipsed = `${value.substring(0, startEllipsIndex)}..${value.substring(endIndex)}`;
        // there is the case that the ellipsed is the same size or larger than the original, avoid that
        if (ellipsed.length < value.length) {
          return ellipsed;
        }
      }
    }

    return value;
  }

}
